/* import __COLOCATED_TEMPLATE__ from './grid-area.hbs'; */
/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes */
import Component from '@ember/component';
import { inject as service } from '@ember/service';
import { computed, action } from '@ember/object';
import $ from 'jquery';

$.fn.exists = function () {
  return this.length !== 0;
};

////////////////////////////////////////////////////////////////////////////////////
// grid-area - Component that displays table of recommended parts & links to PST  //
////////////////////////////////////////////////////////////////////////////////////

export default class GridArea extends Component {
  tagName = '';
  grid = null;
  @service('aditools-analytics') analytics;
  isExpandedTableOpen = null;

  ////////////////////////////////////////////////////////////////////////////////
  // Computed Values                                                            //
  ////////////////////////////////////////////////////////////////////////////////

  @computed('isDiffPGIASchematic') get showRecommendedInAmpsFilter() {
    return !this.isDiffPGIASchematic;
  }

  @computed('recommendedParts') get gridDisplayData() {
    return this.recommendedParts.map((part, index) => {
      return {
        id: part.id,
        description: part.description,
        url: `${this.adiBaseURL}/${part.url}${this.urlQuestion}`,
        rowColor: index % 2 === 0 ? 'even' : 'odd',
      };
    });
  }

  ////////////////////////////////////////////////////////////////////////////////
  // User Functions                                                             //
  ////////////////////////////////////////////////////////////////////////////////

  sendAnalytics(act, partId) {
    switch (act) {
      case 'recommendedList':
        this.analytics.setWebEvent(this.toolConfigData.toolName, 'openParametricTable', this.recommendedInAmpsUrl);
        break;
      case 'recommended':
        this.analytics.setWebEvent(this.toolConfigData.toolName, 'openParametricTable', '');
        break;
      case 'part':
        if (partId) this.analytics.setWebEvent(this.toolConfigData.toolName, 'productView', partId);
        break;
    }
  }

  ////////////////////////////////////////////////////////////////////////////////
  // Component Actions                                                          //
  ////////////////////////////////////////////////////////////////////////////////

  @action insertingHover() {
    $(function () {
      $('#recommended-parts-links .link-with-img').hover(
        function () {
          var e = $(this).find('>img:first-of-type');
          e.data('originalSrc', e.attr('src'));
          e.attr('src', e.attr('data-rollover'));
        },
        function () {
          var e = $(this).find('>img:first-of-type');
          e.attr('src', e.data('originalSrc'));
        },
      );
    });
  }

  @action linkClicked(evt) {
    var act = evt.target.getAttribute('data-action') || '';
    this.sendAnalytics(act, '');
  }

  @action openExpandedTable() {
    this.set('isExpandedTableOpen', true);
  }

  @action closeExpandedTable() {
    this.set('isExpandedTableOpen', false);
  }
}
